// extracted by mini-css-extract-plugin
module.exports = {"table":"AccountsTable_table__3QKL3","thead":"AccountsTable_thead__3KZ5v","tr":"AccountsTable_tr__XztLq","tbody":"AccountsTable_tbody__29eqD","td":"AccountsTable_td__BDKqO"};